import { z } from "zod";

export enum ProposalTableColumnFieldTypes {
  Text = "text",
  CheckLabel = "checkLabel",
  SelectNumber = "select-number",
  SelectCurrency = "select-currency",
  SelectNumberCurrency = "select-number-currency",
}

export enum ProposalTableCheckLabelStatus {
  Positive = "positive",
  Negative = "negative",
}

const optionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

const selectNumberFieldSchema = optionSchema.extend({
  type: z.literal(ProposalTableColumnFieldTypes.SelectNumber),
  name: z.string(),
  options: z.array(
    optionSchema.extend({
      type: z.literal(ProposalTableColumnFieldTypes.SelectNumber),
    }),
  ),
});

const selectCurrencyFieldSchema = optionSchema.extend({
  type: z.literal(ProposalTableColumnFieldTypes.SelectCurrency),
  name: z.string(),
  options: z.array(
    optionSchema.extend({
      type: z.literal(ProposalTableColumnFieldTypes.SelectCurrency),
    }),
  ),
});

const selectNumberCurrencyFieldSchema = optionSchema.extend({
  type: z.literal(ProposalTableColumnFieldTypes.SelectNumberCurrency),
  name: z.string(),
  options: z.array(
    optionSchema.extend({
      type: z.literal(ProposalTableColumnFieldTypes.SelectNumberCurrency),
    }),
  ),
});

const checkLabelFieldSchema = optionSchema.extend({
  type: z.literal(ProposalTableColumnFieldTypes.CheckLabel),
  status: z.union([
    z.literal(ProposalTableCheckLabelStatus.Negative),
    z.literal(ProposalTableCheckLabelStatus.Positive),
  ]),
  name: z.string(),
});

const textFieldSchema = optionSchema.extend({
  type: z.literal(ProposalTableColumnFieldTypes.Text),
  name: z.string(),
});

export const proposalTableFieldSchema = z.discriminatedUnion("type", [
  selectNumberFieldSchema,
  selectCurrencyFieldSchema,
  selectNumberCurrencyFieldSchema,
  checkLabelFieldSchema,
  textFieldSchema,
]);

export type SelectCurrencyFieldType = z.infer<typeof selectCurrencyFieldSchema>;
export type SelectNumberFieldType = z.infer<typeof selectNumberFieldSchema>;
export type CheckLabelField = z.infer<typeof checkLabelFieldSchema>;
export type TextField = z.infer<typeof textFieldSchema>;
export type ProposalTableFieldType = z.infer<typeof proposalTableFieldSchema>;
